<template>
  <div id="credit_card2" class="description">
    <div class="card-wrapper" />
    <!-- /.Card -->
    <div class="form-container">
      <form id="card_form" action="" class="card-form">
        <div class="form-group">
          <label for="card_number">{{ $t("payment.cardnumber") }}</label>
          <div class="input-img">
            <input
              id="card_number"
              class="input form-control"
              name="number"
              :placeholder="$t('payment.cardnumber')"
              type="text"
              v-model.lazy="card_number"
            />
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-6">
            <label for="expiration_date">{{ $t("payment.expdate") }}</label>
            <input
              id="expiration_date"
              class="input form-control"
              placeholder="MM/YY"
              type="tel"
              name="expiry"
              v-model="card_exp_date"
            />
          </div>
          <div class="form-group col-md-6">
            <label for="security_code">{{ $t("payment.securitycode") }}</label>
            <div class="form-group has-search">
              <input
                id="security_code"
                class="input form-control"
                name="cvc"
                :placeholder="$t('payment.securitycode')"
                type="number"
                v-model="card_cvc"
              />
              <img
                src="@/assets/img/security-code.png"
                alt=""
                class="form-control-feedback"
              />
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="name_on_card">{{ $t("payment.nameoncard") }}</label>
          <input
            id="name_on_card"
            class="form-control"
            :placeholder="$t('payment.nameoncard')"
            type="text"
            name="name"
            v-model="card_name"
          />
        </div>
      </form>
    </div>
    <!-- /.Card form -->
  </div>
</template>

<script>
import Card from "card";
import { sync } from "vuex-pathify";

export default {
  name: "CreditCardPayment",
  data() {
    return {
      card: {
        number: null,
        cvc: null,
        exp_month: "",
        exp_year: "",
        exp_date: null,
      },

      // validation
      cardNumberError: this.$t("payment.error_cardnumber"),
      cardCvcError: this.$t("payment.error_cvc"),
      cardMonthError: this.$t("payment.error_expiration"),
      cardYearError: null,
      cardCheckSending: false,
      cardCheckError: false,
      cardCheckErrorMessage: "",
      cardObj: null,
    };
  },

  computed: {
    card_number: sync("card@card_number"),
    card_cvc: sync("card@cvv2"),
    card_exp_month: sync("card@exp.month"),
    card_exp_year: sync("card@exp.year"),
    card_name: sync("card@name"),
    card_exp_date: {
      get() {
        if (this.card_exp_month && this.card_exp_year) {
          return this.card_exp_month + " / " + this.card_exp_year;
        } else {
          return null;
        }
      },
      set(value) {
        var parts = value.split(" / ", 2);

        if (parts.length == 2) {
          this.card_exp_month = parts[0];
          this.card_exp_year = parts[1];
        }
      },
    },
  },

  mounted() {
    this.cardObj = new Card({
      form: "form.card-form",
      container: ".card-wrapper",
      formatting: true,
      placeholders: {
        number: "**** **** **** ****",
        name: "Desmond Doss",
        expiry: "**/****",
        cvc: "***",
      },
    });
  },

  methods: {
    validate() {
      this.showValidation = true;
      this.card.number = this.cardObj.$numberInput[0].value;
      this.card.cvc = this.cardObj.$cvcInput[0].value;
      this.name = this.cardObj.$nameInput[0].value;
      const expDate = this.cardObj.$expiryDisplay[0].innerText;
      this.card.exp_month = null;
      this.card.exp_year = null;
      const split = expDate.split("/");
      if (split.length > 0) {
        this.card.exp_month = split[0]; // eslint-disable-line prefer-destructuring
        this.card.exp_year = split[1]; // eslint-disable-line prefer-destructuring
      }

      this.clearCardErrors();
      let valid = true;
      this.$validator.validateAll().then((result) => {
        if (result) {
          // TODO check
        }
        if (!this.card.number) {
          valid = false;
          this.cardNumberError = this.$t("payment.error_cardnumber");
        }
        if (!this.card.cvc) {
          valid = false;
          this.cardCvcError = this.$t("payment.error_cvc");
        }
        if (this.card.exp_month === "**") {
          valid = false;
          this.cardMonthError = this.$t("payment.error_expiration");
        }
        if (!this.card.exp_year) {
          valid = false;
          this.cardMonthError = this.$t("payment.error_expiration");
        }
        if (valid) {
          this.createToken();
        }
      });
    },
    clearCardErrors() {
      this.cardNumberError = null;
      this.cardCvcError = null;
      this.cardMonthError = null;
      this.cardYearError = null;
    },
  },
};
</script>
